module.exports = __webpack_public_path__ + "static/media/signup2.017542ee.jpg";